<template>
	<div class="useri_right">
			<div class="useri_right_pad">
				<div class="userirp_d1"><span></span>收货地址</div>
				<el-table :data="tableData" border style="width: 100%">
					<el-table-column prop="name" label="收货人">
					</el-table-column>
					<el-table-column prop="city" label="所在地址">
					</el-table-column>
					<el-table-column prop="address" label="详细地址">
					</el-table-column>
					<el-table-column prop="phone" label="手机号">
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="120">
						<template slot-scope="scope">
							<span v-if="defIndex === scope.$index" class="userirp_d1_defaddress">
								默认地址
							</span>
							<el-button v-else @click.native.prevent="setRow(scope.$index,tableData)" type="text" size="small">
								设为默认
							</el-button>
							<el-button @click.native.prevent="deleteRow(scope.$index, tableData)" type="text" size="small">
								移除
							</el-button>
						</template>
					</el-table-column>
				</el-table>

				<div class="userirp_d1 userirp_address_tips"><span></span>新增收货地址</div>
				<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="收货人" prop="name">
						<el-input class="userirp_d1_inp_address" v-model="ruleForm.name" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="手机号" prop="phone">
						<el-input class="userirp_d1_inp_address" v-model="ruleForm.phone" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="所在地区" prop="checkPass">
						<el-select class="userirp_d1_select_city" v-model="ruleForm.selectedProvince" placeholder="请选择省" @change="getCityData">
							<el-option v-for="(item, index) in provinces" :value="item" :key="index">{{ item }}</el-option>
						</el-select>
						<el-select class="userirp_d1_select_city" v-model="ruleForm.selectedCity" placeholder="请选择市" @change="getDistrictData">
							<el-option v-for="(item, index) in cities" :value="item.Name" :key="index">{{ item.Name }}</el-option>
						</el-select>
						<el-select class="userirp_d1_select_city" v-model="ruleForm.selectedDistrict" placeholder="请选择区" @change="getAreaId()">
							<el-option v-for="item in districts" :value="item.Name" :label="item.Name" :key="item.id">{{ item.Name }}</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="详细地址" prop="address">
						<el-input class="userirp_d1_inp_address" v-model="ruleForm.address" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="设为默认">
						<el-switch v-model="ruleForm.delivery"></el-switch>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
						<el-button @click="resetForm('ruleForm')">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
</template>

<script>
	export default {

		data() {
			var validateName = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('收货人不能为空'));
				}
				callback();
			};
			var validatePhone = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('手机号不能为空'));
				} else if (!(/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value))) {
					callback(new Error('手机号校验不通过'));
				} else {
					callback();
				}
			};
			var validateAddress = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('详细地址不能为空'));
				} else {
					callback();
				}
			};
			return {
				addressList: [],
				defIndex: 0,
				provinces: [],
    			cities: [],
    			districts: [],
				AreaId:'',
				ruleForm: {
					name: '',
					phone: '',
					address: '',
					selectedProvince: '',
					selectedCity: '',
					selectedDistrict: '',
					delivery: false,
				},
				rules: {
					name: [{
						validator: validateName,
						trigger: 'blur'
					}],
					phone: [{
						validator: validatePhone,
						trigger: 'blur'
					}],
					address: [{
						validator: validateAddress,
						trigger: 'blur'
					}],
					selectedProvince: [{
						required: true,
						message: '请选择省',
						trigger: 'change'
					}],
					selectedCity: [{
						required: true,
						message: '请选择市',
						trigger: 'change'
					}],
					selectedDistrict: [{
						required: true,
						message: '请选择区',
						trigger: 'change'
					}],
				},
				tableData: []
			}
		},
		computed: {

		},
		watch: {

		},
		created: function() {
			this.getProvinces();
			this.MyShippingAdressList()
		},
		mounted: function() {
			this.getProvinces();
		},
		methods: {
			async getProvinces() {
    	        let res = await this.$post("DefaultProvList", {});
    	        // console.log(res,'DefaultProvList');
    	        this.provinces = res.data.ResultData.ProvinceList;
    	    },
    	    async getCityData() {
    	        let res = await this.$post("GetCityTownList", {province:this.ruleForm.selectedProvince});
    	        console.log(this.ruleForm.selectedProvince,'GetCityTownList');
    	        this.cities = res.data.ResultData.CityList;
				this.ruleForm.selectedCity = '';
    	        this.districts = [];
    	    	this.ruleForm.selectedDistrict = '';
			},
    	    async getDistrictData() {
    	        let res = await this.$post("GetTownList", {city:this.ruleForm.selectedCity});
    	        console.log(res,'GetTownList');
    	        this.districts = res.data.ResultData;
				this.ruleForm.selectedDistrict = '';
          	},
			getAreaId(){
				const selectedDistrictName = this.ruleForm.selectedDistrict;
      			const selectedOption = this.districts.find(item => item.Name === selectedDistrictName);
      			if (selectedOption) {
        			this.AreaId = selectedOption.id;
      			}
				console.log(this.AreaId,'getAreaId');
			},
			submitForm(formName) {
				var that = this;
				that.$refs[formName].validate(async (valid) => {
					if (valid) {
						var res = await this.$post("AddShippingAdress", {
                		Name: this.ruleForm.name,
                		Mobile: this.ruleForm.phone,
                		AreaId: this.AreaId,
                		Adress: this.ruleForm.address,
                		ShippingId: this.id,
            		})
					console.log(res, '新增/修改');
					this.MyShippingAdressList();
					this.resetForm('ruleForm');
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			MyShippingAdressList() {
				var that = this
				that.tableData = []
				that.$post('MyShippingAdressList', {
						UserId: that.$store.state.userId
					})
					.then(function(res) {
						var list = res.data.ResultData
						for (var i in list) {
							if(list[i].IsDeafult){
								that.defIndex = parseInt(i)
							}
							that.tableData.push({
								id:list[i].id,
								name: list[i].Name,
								city: list[i].PathName,
								address: list[i].Adress,
								phone: list[i].Mobile
							})
						}
					})
			},
			resetForm(formName) {
				this.ruleForm.selectedProvince = ''
				this.ruleForm.selectedCity = ''
				this.ruleForm.selectedDistrict = ''
				this.$refs[formName].resetFields();
			},
			setRow(index, rows){
				console.log(index)
				console.log(rows[index].id)
				var that = this;
				that.$post('SetDeafultShippingAdress', {
						UserId: that.$store.state.userId,
						ShippingId:rows[index].id
					})
					.then(function(res) {
						if(res.data.Success == "true"){
							that.$message({
								message: res.data.Msg,
								type: 'success'
							});
							that.MyShippingAdressList()
						}else{
							that.$message.error(res.data.Msg);
						}
					})
			},
			async deleteRow(index, rows) {
				var id =rows[index].id;
				await this.$confirm("此操作将永久删除该条地址，是否继续?", "提示", {
        			confirmButtonText: "确定",
        			cancelButtonText: "取消",
        			type: "warning",
					customClass: 'msgbox'
      			});
				var res = await this.$post("DelShippingAdress",{ShippingId:id})
    			console.log(res,'删除');
				this.MyShippingAdressList();
			},
			
			toPwd() {
				this.$router.push("/setPwd")
			},
			toAddress() {
				this.$router.push("/address")
			},
			toOrderList() {
				this.$router.push("/orderList")
			},
			toFast() {
				this.$router.push("/fast")
			},
			toSetPwd() {
				this.$router.push("/setPwd")
			},
			toUserInfo() {
				this.$router.push("/userInfo")
			},
			toCar() {
				this.$router.push("/car")
			}
		}
	}
</script>

<style >
@media (max-width: 992px) {
  .msgbox{
    width: 320px !important;
  }
}
</style>
<style scoped>
    
 .userirp_d1_defaddress{
	 color: red;
	 font-size: 12px;
	 margin-right: 9px;
 }
 
 .userirp_address_tips{
	 margin-top: 25px;
 }
 .userirp_d1_inp_address{
	width: 90%;
 }
</style>